module.exports = __webpack_public_path__ + "media/customizations/northspur/logo-7760299c806374f366d6ad7c42b75d08.png";